import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex mt-5"
}
const _hoisted_2 = {
  class: "attendance-summary-block",
  style: {"flex":"1"}
}
const _hoisted_3 = { class: "attendance-label-small" }
const _hoisted_4 = { class: "attendance-label-medium my-2" }
const _hoisted_5 = { class: "attendance-label-large" }
const _hoisted_6 = { class: "attendance-label-small" }
const _hoisted_7 = { class: "my-2 d-flex justify-center align-center" }
const _hoisted_8 = { class: "attendance-label-medium" }
const _hoisted_9 = { class: "attendance-label-large" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "text-primary ml-6"
}
const _hoisted_12 = { class: "ml-6" }
const _hoisted_13 = { class: "d-flex align-center justify-space-between w-100" }
const _hoisted_14 = { class: "d-flex align-center" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "text-primary ml-6"
}
const _hoisted_18 = { class: "ml-6" }
const _hoisted_19 = { class: "d-flex align-center justify-space-between w-100 mt-2" }
const _hoisted_20 = {
  class: "d-flex flex-column mt-2",
  style: {"width":"100%","overflow-wrap":"anywhere","white-space":"pre-line"}
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "fab-wrapper" }
const _hoisted_23 = { class: "fab-items mb-4" }
const _hoisted_24 = { class: "py-2 px-4" }
const _hoisted_25 = { class: "py-2 px-4" }
const _hoisted_26 = { class: "py-2 px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_MemoForm = _resolveComponent("MemoForm")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_AbsenceListModal = _resolveComponent("AbsenceListModal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_slide_y_reverse_transition = _resolveComponent("v-slide-y-reverse-transition")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_vue_pull_refresh = _resolveComponent("vue-pull-refresh")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_vue_pull_refresh, { onRefresh: _ctx.reload }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
        }, [
          _createVNode(_component_DatePager, {
            date: _ctx.date,
            onAddDay: _ctx.addDay,
            onSubtractDay: _ctx.subtractDay
          }, null, 8, ["date", "onAddDay", "onSubtractDay"])
        ]),
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.tabIndex,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabIndex) = $event)),
          color: "primary",
          grow: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "attendance" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('communication.attendanceList')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "memo" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('communication.noteList')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.chatSummary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('communication.currentChildrenCount')), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.chatSummary ? (_ctx.chatSummary.presentChildrenCount - _ctx.chatSummary.leftChildrenCount) : 0), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.personLabel(_ctx.chatSummary ? (_ctx.chatSummary.presentChildrenCount - _ctx.chatSummary.leftChildrenCount) : 0)) + "/" + _toDisplayString(_ctx.chatSummary ? _ctx.chatSummary.totalChildrenCount : 0) + " " + _toDisplayString(_ctx.personLabel(_ctx.chatSummary ? _ctx.chatSummary.totalChildrenCount : 0)), 1)
                ])
              ]),
              _createElementVNode("div", {
                style: {"flex":"1"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.absenceDialog = true))
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('communication.absent')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.chatSummary.absences.length), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.personLabel(_ctx.chatSummary.absences.length)), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_tabs_window, {
          modelValue: _ctx.tabIndex,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tabIndex) = $event)),
          "show-arrows": false,
          touchless: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs_window_item, { value: "attendance" }, {
              default: _withCtx(() => [
                (!_ctx.fetchLoading && _ctx.clasSummary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clasSummary, (clas, index) => {
                        return (_openBlock(), _createBlock(_component_v_list, {
                          key: index,
                          density: "compact"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_subheader, { class: "attendance-list-header d-flex align-center w-100" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(clas.className) + " ", 1),
                                (clas.isInCharge)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('communication.inChargeClass')), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_12, _toDisplayString((clas.presentChildrenCount - clas.leftChildrenCount)) + "/" + _toDisplayString(clas.totalChildrenCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clas.childrenAttendance, (attendance, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                to: `/communication/chat/${attendance.child.childId}?date=${_ctx.date.toISOString()}`
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", null, [
                                      (_ctx.predictFever(attendance.isFeverAlert))
                                        ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                              _createTextVNode("mdi-emoticon-sick", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(attendance.child.lastName) + " " + _toDisplayString(attendance.child.firstName) + " ", 1),
                                      (attendance.status === 1)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            color: "primary",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedIn')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.status === 2)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 2,
                                            color: "secondary",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedOut')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.absence === 1)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 3,
                                            color: "grey",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.absent')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.pickup)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            (attendance.pickup.dropOff.by || attendance.pickup.pickup.by)
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 0,
                                                  color: "orange",
                                                  class: "mx-2",
                                                  variant: "outlined",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('attendance.pickupChanged')), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      (attendance.comment && attendance.comment.comment)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            color: "#E190CF"
                                          }, {
                                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                              _createTextVNode("mdi-note-outline", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.chatUnreadCount > 0)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            color: "primary",
                                            class: "mx-2 pa-2",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(attendance.chatUnreadCount), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                          _createTextVNode("mdi-chevron-right", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_VueLoading, { height: '50vh' })
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window_item, { value: "memo" }, {
              default: _withCtx(() => [
                (!_ctx.fetchLoading && _ctx.clasSummary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clasSummary, (clas, index) => {
                        return (_openBlock(), _createBlock(_component_v_list, {
                          key: index,
                          density: "compact"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_subheader, { class: "attendance-list-header d-flex align-center w-100" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(clas.className) + " ", 1),
                                (clas.isInCharge)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('attendance.inCharge')), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(clas.presentChildrenCount) + "/" + _toDisplayString(clas.totalChildrenCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clas.childrenAttendance, (attendance, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", null, [
                                      _createTextVNode(_toDisplayString(attendance.child.lastName) + " " + _toDisplayString(attendance.child.firstName) + " ", 1),
                                      (attendance.status === 1)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            color: "primary",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedIn')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.status === 2)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            color: "secondary",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedOut')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.absence === 1)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 2,
                                            color: "grey",
                                            class: "mx-2",
                                            variant: "outlined",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('attendance.absent')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (attendance.pickup)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            (attendance.pickup.dropOff.by || attendance.pickup.pickup.by)
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 0,
                                                  color: "orange",
                                                  class: "mx-2",
                                                  variant: "outlined",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('attendance.pickupChanged')), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_MemoForm, {
                                      comment: [
                    attendance.comment && attendance.comment.comment
                      ? attendance.comment.comment
                      : '',
                  ],
                                      date: _ctx.date,
                                      child: attendance.child,
                                      onSaveComment: _ctx.showSnackBar
                                    }, null, 8, ["comment", "date", "child", "onSaveComment"]),
                                    _createVNode(_component_v_divider)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_VueLoading, { height: '50vh' })
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.absenceDialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.absenceDialog) = $event)),
          fullscreen: "",
          "hide-overlay": "",
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AbsenceListModal, {
              chatsAbsence: _ctx.chatsAbsence,
              isOpen: _ctx.absenceDialog,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.absenceDialog = false))
            }, null, 8, ["chatsAbsence", "isOpen"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_v_slide_y_reverse_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_23, [
                _createVNode(_component_v_btn, {
                  color: "#6C6C6C",
                  rounded: "xl",
                  size: "large",
                  class: "mb-3 text-white",
                  to: `/communication/draft`,
                  elevation: "10",
                  style: {"height":"auto","min-height":"48px","white-space":"normal"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('communication.openDraft')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  rounded: "xl",
                  variant: "outlined",
                  size: "large",
                  class: "mb-3 bg-white",
                  to: `/communication/ready-send-box`,
                  elevation: "10",
                  style: {"height":"auto","min-height":"48px","white-space":"normal"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('communication.openReadySendBox')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  rounded: "xl",
                  size: "large",
                  class: "mb-3",
                  to: `/communication/new-message`,
                  elevation: "10",
                  style: {"height":"auto","min-height":"48px","white-space":"normal"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('communication.createBroadcastMessage')), 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isFabOpen]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            color: "primary",
            icon: "",
            size: "x-large",
            elevation: "10",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isFabOpen = !_ctx.isFabOpen))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "large" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isFabOpen ? 'mdi-close' : 'mdi-plus'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.snackbar,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.snackbar) = $event)),
          timeout: _ctx.timeout,
          outlined: "",
          top: "",
          color: "primary"
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "outline-primary",
              variant: "text",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.snackbar = false))
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" × ", -1)
              ]))]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "timeout"])
      ]),
      _: 1
    }, 8, ["onRefresh"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto",
      "max-width": "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, {
          locale: _ctx.$i18n.locale
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              "hide-header": "",
              color: "primary"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["locale"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}